import React, { useEffect, useState } from 'react';
import Excel from 'exceljs';
import { useNavigate } from "react-router-dom";
import axios from "axios";

const EnvioExcelMasivoItalika = () => {

    const [apiResponse, setApiResponse] = useState("");
    const loggedIn = sessionStorage.getItem("loggedIn");
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    const clienteid = userData?.clienteid;
    const navigate = useNavigate();

    useEffect(() => {
        if (!loggedIn) {
            navigate("/login");
        }
        //else{
            //getEmpresas();
        //}
    }, []);


    const handleChange = (e) => {
        const file = e.target.files[0];
        const wb = new Excel.Workbook();
        const reader = new FileReader();

        reader.readAsArrayBuffer(file);
        reader.onload = () => {
            const buffer = reader.result;
            wb.xlsx.load(buffer).then((workbook) => {
                //console.log(workbook, 'workbook instance');
                workbook.eachSheet((sheet, id) => {
                    sheet.eachRow((row, rowIndex) => {
                        //console.log(row.values, rowIndex);
                        const empresa3 = JSON.stringify(row.values, rowIndex);
                        //console.log(empresa3);
                        const PedidoData2 = JSON.parse(empresa3);
                        //console.log(PedidoData2[1]);

                        const FechaRecoleccion = PedidoData2[1];
                        const NombreRemitente = PedidoData2[2];
                        const NombreAgenciaDestino = PedidoData2[3];
                        const Remision = PedidoData2[4];
                        const Caja = PedidoData2[5];
                        const PesoVolumetrico = PedidoData2[6];
                        const Peso = PedidoData2[7];
                        const Largo = PedidoData2[8];
                        const Ancho = PedidoData2[9];
                        const Alto = PedidoData2[10];
                        //const clienteid = PedidoData2[11];
                        const Guia = PedidoData2[11];
                        const FechaEntrega = PedidoData2[12];
                        const EstatusPaquete = PedidoData2[13];
                        const Servicio = PedidoData2[14];
                        const NombreRecibe = PedidoData2[15];
                        const Precio = PedidoData2[16];
                        const ImagenEvidencia = PedidoData2[17];
                        /*
                        const numeroOrigen = PedidoData2[18];
                        const cpOrigen = PedidoData2[19];
                        const coloniaOrigen = PedidoData2[20];
                        const alcaldiaOrigen = PedidoData2[21];
                        const referenciasOrigen = PedidoData2[22];
                        const valor = PedidoData2[23];
                        const peso = PedidoData2[24];
                        const largo = PedidoData2[25];
                        const ancho = PedidoData2[26];
                        const altura = PedidoData2[27];
                        const proteccion = PedidoData2[28];
                        */


                        /*Guarda datos Inicio*/
                        axios
                        .post("https://boxerlogistica.com/api/Nuevo_Pedido_Italika.php", {
                          FechaRecoleccion: FechaRecoleccion,
                          NombreRemitente: NombreRemitente,
                          NombreAgenciaDestino: NombreAgenciaDestino,
                          Remision: Remision,
                          Caja: Caja,
                          PesoVolumetrico: PesoVolumetrico,
                          Peso: Peso,
                          Largo: Largo,
                          Ancho: Ancho,
                          Alto: Alto,
                          Guia: Guia,
                          FechaEntrega: FechaEntrega,
                          EstatusPaquete: EstatusPaquete,
                          Servicio: Servicio,
                          NombreRecibe: NombreRecibe,
                          Precio: Precio,
                          ImagenEvidencia: ImagenEvidencia,
                          clienteid: clienteid
                          //numeroOrigen: numeroOrigen,
                          //cpOrigen: cpOrigen,
                          //coloniaOrigen: coloniaOrigen,
                          //alcaldiaOrigen: alcaldiaOrigen,
                          //referenciasOrigen: referenciasOrigen
                          //ancho: ancho,
                          //largo: largo,
                          //peso: peso
                        })
                        .then((response) => {
                            //console.log('workbook instance');
                            //console.log(response);
                          setApiResponse(response.data.status);
                          //setNewPedidos(response.data.data);
                          //const lastid = response.data.data.lastid;
                          //const seguimientoID = response.data.data.seguimientoID;
                  
                          if (response.data.status === "Final") {
                            console.log(response.data.status)
                            //window.location.href = "/EnvioCorrectoMasivoItalika";

                            //window.location.href = "/EnvioPaquete";
                            /******  Guarda datos Paquete Inicio *****/
                            /*
                                        axios
                                        .post("https://boxerlogistica.com/api/Nuevo_Paquete.php", {
                                        proteccion: proteccion.proteccion,
                                        valor: valor,
                                        lastid: lastid,
                                        seguimientoID: seguimientoID,
                                        clienteid: clienteid,
                                        altura: altura,
                                        ancho: ancho,
                                        largo: largo,
                                        peso: peso
                                        })
                                        .then((response) => {
                                        //console.log(response);
                                        setApiResponse(response.data.status);
                                        if (response.data.status === "success") {
                                            window.location.href = "/EnvioCorrectoMasivo";
                                        }else{
                                            window.location.href = "/EnvioerrorMasivo";
                                        }
                                        })
                                        .catch((error) => {
                                        console.error(error);
                                        setApiResponse(error.response.data.message);
                                        });
                                */
                            /* Guarda datos Paquete Fin*/

                          }else{
                            //alert('File uploaded Incorrectly!');
                            //window.location.href = "/EnvioerrorMasivoItalika";
                            //window.location.href = "/EnvioCorrectoMasivoItalika";
                           console.log(response.data.status)
                          }
                        })
                        .catch((error) => {
                          //console.error(error);
                          setApiResponse(error.response.data.message);
                        });
                        /* Guarda datos Fin*/

                        //console.log(response.data.status)
                        
                    });
                });
                alert('File uploaded successfully!');
            });
        };
    };

    return (
        <div>
            <div>Upload Excel File</div>
            <input type='file' onChange={(e) => handleChange(e)} />
        </div>
    );
};

EnvioExcelMasivoItalika.propTypes = {};
EnvioExcelMasivoItalika.defaultProps = {};

export default EnvioExcelMasivoItalika;